import { render } from "./Description.vue?vue&type=template&id=80d6fed0&scoped=true"
import script from "./Description.vue?vue&type=script&lang=js"
export * from "./Description.vue?vue&type=script&lang=js"

import "./Description.vue?vue&type=style&index=0&id=80d6fed0&scoped=true&lang=css"
import "./Description.vue?vue&type=style&index=1&id=80d6fed0&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80d6fed0"]])

export default __exports__